export default __webpack_public_path__ + "static/media/k_wdt_c_3.0fcb5850.mp3";